export const targetTypesDescriptions = {
  specialty: 'Especialidad',
  profesion: 'Profesion',
};
